import moment from "moment";
import { dayMapper } from "../../helpers/tools";

export const adaptNPIDResumen = (data) => {
    const {
        nutricionParenteralRI,
        laboratorioAdjunto,
        indicacionRI,
        diaConexionEstandar,
        diaConexionMagistral
    } = data;

    return {
        presenciaEdemas: nutricionParenteralRI?.presenciaEdemas,
        proteinasTotalesNPID: nutricionParenteralRI?.proteinasTotales,
        lipidosTotalesNPID: nutricionParenteralRI?.lipidosTotales,
        caloriasTotalesNPID: nutricionParenteralRI?.caloriasTotales,
        laboratorioNPID: nutricionParenteralRI?.laboratorio,
        laboratorioAdjuntoNPID: {
            contentType: laboratorioAdjunto?.contentType,
            archivo: laboratorioAdjunto?.archivo,
            extension: laboratorioAdjunto?.extension,
            titulo: laboratorioAdjunto?.titulo,
        },
        comboRIValorKarnofskyNPID: nutricionParenteralRI?.idComboRIValorKarnofskyNavigation?.valor,
        comboRIValorFAV: nutricionParenteralRI?.idComboRIValorFAVNavigation?.valor,
        comboRIValorTipoCateter: nutricionParenteralRI?.idComboRIValorTipoCateterNavigation?.valor,
        fechaColocacionNPID: moment(nutricionParenteralRI?.fechaColocacion).format('DD/MM/YYYY'),
        comboRIValorUbicacionNPID: nutricionParenteralRI?.idComboRIValorUbicacionNavigation?.valor,
        comboRIValorNroLumenesNPID: nutricionParenteralRI?.idComboRIValorNroLumenesNavigation?.valor,
        cateterNormalNPID: nutricionParenteralRI?.cateterNormal,
        bAPestandarNPID: nutricionParenteralRI?.bAPestandar,
        magistralNPID: nutricionParenteralRI?.magistral,
        volumenMagistralNPID: nutricionParenteralRI?.volumenMagistral,
        comboRIValorMotivoIndicacionMagistralNPID: nutricionParenteralRI?.idComboRIValorMotivoIndicacionMagistralNavigation?.valor,
        nombreInsumoNPID: indicacionRI?.idInsumoNavigation?.descripcion,
        cantidadDiariaNPID: indicacionRI?.cantidadDiaria,
        diasConexionSemanaNPID: diaConexionEstandar?.map(day => dayMapper[day]),
        diasConexionSemanaMagistralNPID: diaConexionMagistral?.map(day => dayMapper[day])
    }
}